import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import usePPAChanneld from 'hooks/usePPAChanneld';

const JoinKiwiHealth: React.FC<{ className: string; }> = ({
    className,
}) => {
    const navigate = useNavigate();
    const [ppaId, loadingPPA] = usePPAChanneld();
    return (
        <div className={`${s.wrapper} ${className}`}>
            <div className={s.content}>
                <div className={s.title}>
                    Join Klarity Health
                </div>
                <div className={s.desc}>
                    Opt into Klarity Health for free to attract more patients. You only need to pay when there is an appointment scheduled on your calendar.
                </div>
                <div className={s.buttonWrap}>
                    <Button
                        type="primary"
                        onClick={() => {
                            navigate(
                                `${PATH.DASHBOARD}/${PATH.CHANNEL_DETAIL}?channelId=${ppaId}`,
                            );
                        }}
                    >
                        Join now
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default JoinKiwiHealth;
